import "../../assets/tailwind/application.css";
import React from "react";
import ReactDOM from "react-dom/client";
import DashboardApp from "../components/DashboardApp";
import LandingApp from "../components/LandingApp";
import HusklyLandingApp from "../components/HusklyLandingApp";
import Header from "../components/Header";
import Flash from "../components/Flash";
import SimpleCookieConsent from "../lib/simpleCookieConsent";

const dashboardElement = document.getElementById("dashboard-app");
const landingElement = document.getElementById("aegis-vol-app");
const husklyLandingElement = document.getElementById("huskly-landing-app");
const headerElement = document.getElementById("header-app");
const flashElement = document.getElementById("flash-app");

if (dashboardElement) {
  ReactDOM.createRoot(dashboardElement).render(
    <React.StrictMode>
      <DashboardApp />
    </React.StrictMode>,
  );
}

if (landingElement) {
  ReactDOM.createRoot(landingElement).render(
    <React.StrictMode>
      <LandingApp />
    </React.StrictMode>,
  );
}

if (husklyLandingElement) {
  ReactDOM.createRoot(husklyLandingElement).render(
    <React.StrictMode>
      <HusklyLandingApp />
    </React.StrictMode>,
  );
}

if (headerElement) {
  const dataset = headerElement.dataset;
  ReactDOM.createRoot(headerElement).render(
    <React.StrictMode>
      <Header
        compact={dataset.compact === "true"}
        currentUser={dataset.currentUser === "true"}
        admin={dataset.admin === "true"}
        showNav={dataset.showNav === "true"}
        selectedItem={dataset.selectedItem as any}
        formAuthenticityToken={dataset.formAuthenticityToken}
        title={dataset.title}
      />
    </React.StrictMode>,
  );
}

if (flashElement) {
  const { notice, alert } = flashElement.dataset;
  ReactDOM.createRoot(flashElement).render(
    <React.StrictMode>
      <Flash notice={notice} alert={alert} />
    </React.StrictMode>,
  );
}

const cc = new SimpleCookieConsent({
  title: "We respect your privacy",
  description:
    "Huskly uses cookies to understand usage and improve your experience. Accept analytics to help us learn, or reject to opt out.",
});
cc.on("change", (cc) => {
  console.log("change in cookie settings", cc.acceptedCategories);
  window.updateAnalytics(cc);
});
// to make sure it is loaded once.
window.updateAnalytics(cc);
